// Local imports
import html from '../images/icons/html5.svg';
import css from '../images/icons/css.svg';
import react from '../images/icons/react.svg';
import javascript from '../images/icons/javascript.svg';
import nodejs from '../images/icons/nodejs.svg';
// redux and bootstrap icons removed - not featured on resume
import git from '../images/icons/github.svg';
import python from '../images/icons/python.png';
import java from '../images/icons/Java.png';
import springBoot from '../images/icons/Spring.png';
import aws from '../images/icons/Amazon.png';
import tailwind from '../images/icons/TailwindCss.png';
import docker from '../images/icons/Docker.png';
import fastapi from '../images/icons/fastapi.png';
import langchain from '../images/icons/langchain.png';
// gemini icon removed - not featured on resume
import pgvector from '../images/icons/pgvector.png';
import openai from '../images/icons/OpenAI.png';

// External icon URLs (wikimedia, devicons - known working)
const gpt_icon = 'https://upload.wikimedia.org/wikipedia/commons/0/04/ChatGPT_logo.svg';
const typescript_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg';
const nextjs_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original.svg';
const postgresql_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg';
const aws_lambda_icon = 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Amazon_Lambda_architecture_logo.svg';
const aws_s3_icon = 'https://upload.wikimedia.org/wikipedia/commons/b/bc/Amazon-S3-Logo.svg';
const azure_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/azure/azure-original.svg';
const gemini_icon = 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Google_Gemini_logo.svg';

// RAG: unique icon (document + magnifying glass = retrieval) — not LangChain
const rag_icon = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="#a9ff5c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M28 8H12a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V20"/><path d="M32 4v8h8"/><circle cx="22" cy="26" r="6"/><path d="M26 30l8 8"/></svg>'
);

// Eval / Testing: checkmark + beaker (testing)
const eval_testing_icon = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 28l6 6 12-14"/><path d="M24 8v8l6 4 6-4-6-4-6 4V8z"/><path d="M18 20l-4 2v12h20v-12l-4-2"/></svg>'
);

// Structured Outputs: curly braces (JSON/code)
const structured_outputs_icon = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8c-4 4-4 12 0 16s12 4 16 0"/><path d="M32 8c4 4 4 12 0 16s-12 4-16 0"/><path d="M18 24h12"/></svg>'
);

// REST: API/link icon
const rest_icon = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 22l6-6 6 6"/><path d="M24 16v16"/><path d="M14 30H8a4 4 0 0 1-4-4V14a4 4 0 0 1 4-4h8"/><path d="M34 30h6a4 4 0 0 0 4-4V14a4 4 0 0 0-4-4h-8"/></svg>'
);

// SSE / Streaming: signal waves (streaming data)
const sse_icon = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 24h6l4-8 4 16 4-8 4 8h6"/><path d="M4 32h6l4-4 4 8 4-8 4 4h6"/></svg>'
);


// External icon URLs for new skills
const claude_icon = 'https://upload.wikimedia.org/wikipedia/commons/8/8a/Claude_AI_logo.svg';
const d3_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/d3js/d3js-original.svg';
const redis_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original.svg';
const mongodb_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg';
const kafka_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/apachekafka/apachekafka-original.svg';
const kubernetes_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/kubernetes/kubernetes-plain.svg';
const terraform_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/terraform/terraform-original.svg';
const githubactions_icon = 'https://raw.githubusercontent.com/devicons/devicon/master/icons/githubactions/githubactions-original.svg';

// MCP icon (simple connector/plug icon)
const mcp_icon = 'data:image/svg+xml,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="24" cy="24" r="8"/><path d="M24 4v12M24 32v12M4 24h12M32 24h12"/><circle cx="24" cy="4" r="3" fill="#a9ff5c"/><circle cx="24" cy="44" r="3" fill="#a9ff5c"/><circle cx="4" cy="24" r="3" fill="#a9ff5c"/><circle cx="44" cy="24" r="3" fill="#a9ff5c"/></svg>'
);

// Grouped skills: LLM/AI, Backend, Frontend, Cloud/DevOps
export const skillGroups = [
  {
    title: 'ML Infrastructure / GenAI',
    skills: [
      { name: 'OpenAI', image: openai },
      { name: 'Claude', image: claude_icon },
      { name: 'Gemini', image: gemini_icon },
      { name: 'LangChain', image: langchain },
      { name: 'LangGraph', image: langchain },
      { name: 'RAG', image: rag_icon },
      { name: 'pgvector', image: pgvector },
      { name: 'Prompt Eng.', image: gpt_icon },
      { name: 'Eval / Testing', image: eval_testing_icon },
      { name: 'MCP', image: mcp_icon },
    ],
  },
  {
    title: 'Backend',
    skills: [
      { name: 'Python', image: python },
      { name: 'FastAPI', image: fastapi },
      { name: 'Node.js', image: nodejs },
      { name: 'PostgreSQL', image: postgresql_icon },
      { name: 'REST', image: rest_icon },
      { name: 'SSE / Streaming', image: sse_icon },
      { name: 'Java', image: java },
      { name: 'Spring Boot', image: springBoot },
      { name: 'Redis', image: redis_icon },
      { name: 'MongoDB', image: mongodb_icon },
      { name: 'Kafka', image: kafka_icon },
    ],
  },
  {
    title: 'Frontend',
    skills: [
      { name: 'React', image: react },
      { name: 'Next.js', image: nextjs_icon },
      { name: 'TypeScript', image: typescript_icon },
      { name: 'D3.js', image: d3_icon },
      { name: 'Tailwind CSS', image: tailwind },
      { name: 'JavaScript', image: javascript },
      { name: 'HTML', image: html },
      { name: 'CSS', image: css },
    ],
  },
  {
    title: 'Infrastructure',
    skills: [
      { name: 'AWS', image: aws },
      { name: 'Lambda', image: aws_lambda_icon },
      { name: 'S3', image: aws_s3_icon },
      { name: 'Azure', image: azure_icon },
      { name: 'Docker', image: docker },
      { name: 'Kubernetes', image: kubernetes_icon },
      { name: 'Terraform', image: terraform_icon },
      { name: 'GitHub Actions', image: githubactions_icon },
      { name: 'Git', image: git },
    ],
  },
];

// Flat list (for backward compatibility if needed)
export const skill = skillGroups.flatMap((g) => g.skills);
